<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Charge :</label>

        <input name="Charge" v-validate="'required|max:255'" 
               v-model="encodingData.Charge" 
               class="form-control" 
               :class="{ 'is-invalid': submitted && errors.has('Charge') }" />
            <span v-if="submitted && errors.has('Charge')"
                         class="invalid-feedback">
                        {{ errors.first("Charge") }}
            </span>

        <label>Charge Date :</label>

        <input type="date" name="ChargeDate" v-model="encodingData.ChargeDate" class="form-control" />

        <label>Reference No :</label>

        <input name="ReferenceNo"
               v-validate="'max:50'"
               v-model="encodingData.ReferenceNo" 
               class="form-control" 
               :class="{ 'is-invalid': submitted && errors.has('ReferenceNo') }" />
          <span v-if="submitted && errors.has('ReferenceNo')"
               class="invalid-feedback">
              {{ errors.first("ReferenceNo") }}
          </span>

        <label>Authority :</label>

        <input name="Authority" 
               v-validate="'max:255'"
               v-model="encodingData.Authority" 
               class="form-control"
               :class="{ 'is-invalid': submitted && errors.has('Authority') }" />
            <span v-if="submitted && errors.has('Authority')"
                 class="invalid-feedback">
                {{ errors.first("Authority") }}
            </span>

        <label>Country:</label>

        <select name="Country" v-model="encodingData.Country" class="form-control">
          <option value>Select Country</option>
          <option
            v-for="option in countries"
            v-bind:value="option.countryName"
            v-bind:key="option.countryName"
          >{{option.countryName}}</option>
        </select>

        <label>State:</label>

        <select name="SourceId" v-model="encodingData.State" class="form-control">
          <option value>Select State</option>
          <option
            v-for="option in provinces"
            v-bind:value="option.province"
            v-bind:key="option.province"
          >{{option.province}}</option>
        </select>

        <label>City :</label>

        <input type="text" 
               name="City" 
               v-validate="'max:50'"
               v-model="encodingData.City" 
               class="form-control"
               :class="{ 'is-invalid': submitted && errors.has('City') }" />
            <div v-if="submitted && errors.has('City')"
                 class="invalid-feedback">
                {{ errors.first("City") }}
            </div>

        <label>Comments :</label>

        <textarea
          name="Comments"
          v-model="encodingData.Comments"
          rows="5"
          cols="5"
          class="form-control"
        />
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  formatdate,
  getlocalstorageCountry,
  getlocalstorageProvince
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        ChargeId: '',
        Charge: '',
        ChargeDate: null,
        ReferenceNo: '',
        Authority: '',
        Country: '',
        State: '',
        City: '',
        Comments: ''
      },
      countries: [],
      provinces: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created: function() {
    this.getlibs()
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.provinces = getlocalstorageProvince()
      this.getLegal()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updatelegalcharges', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-legal')
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
    getLegal() {
      
      instance
        .get(DataURL + 'legalcharges?legalchargesID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.ChargeId = data.chargeId
              this.encodingData.Charge = data.charge
              this.encodingData.ChargeDate = formatdate(data.chargeDate)
              this.encodingData.ReferenceNo = data.referenceNo
              this.encodingData.Authority = data.authority
              this.encodingData.Country = data.country
              this.encodingData.State = data.state
              this.encodingData.City = data.city
              this.encodingData.Comments = data.comments
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>
